const axios = require('axios').default
import { BASE_URL, WS_VIREED } from './base-url'

var base = BASE_URL;

export default class videoPluginParams {

    getDefaultParametersForClient(token, params) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videopluginparams',
                method: 'get',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                params: params
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error)                
            })
        });
    }

    updateDefaultParametersForClient(data, client, token) {
        return new Promise((done, reject) => {
            var instance = {
                baseURL: base + '/api/videopluginparams/'+client,
                method: 'put',
                headers: {
                    'Authorization': 'Basic ' + token
                },
                data:data
            };
            axios(instance).then((response) => {
                done(response.data);
            }).catch((error) => {
                reject(error)                
            })
        });
    }

}